<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Pages</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Pages</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'CMSPageList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>
                  
                  <li><strong>ID</strong> {{ value.id }}</li>
                  
                  <li><strong>Page Title</strong> {{ value.page_title }}</li>
                  
                  <li><strong>Slug</strong> {{ value.slug_url }}</li>
                  
                  <li><strong>Summery</strong> {{ value.summery }}</li>
                  
                  <li><strong>Content</strong> {{ value.page_content }}</li>
                  
                  <li><strong>Featured Image</strong> 
                      <img v-bind:src="API_ASSET_UPLOAD_URL+value.featured_image" class="img-fluid img-thumbnail rounded" style="width: 200px;">
                      </li>
                  
                  <li><strong>SEO Title</strong> {{ value.seo_title }}</li>
                  
                  <li><strong>SEO Summery</strong> {{ value.seo_summery }}</li>
                  
                  <li><strong>SEO Keywords</strong> {{ value.seo_keywords }}</li>
                  
                  <li><strong>SEO Image</strong> 
                      <img v-bind:src="API_ASSET_UPLOAD_URL+value.seo_image" class="img-fluid img-thumbnail rounded" style="width: 200px;">
                      </li>
                  
                  <li><strong>Text Example</strong> {{ value.extra_contents }}</li>
                  
                  <li><strong>Page Template</strong> {{ value.page_template }}</li>
                  
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from "@/services/api";
import axios from "axios";
const fileDownload = require("js-file-download")
import { Notification } from "element-ui";


export default {
  name: "CMSPageShow",
  metaInfo: {
    title: "CMS Pages | Dotlines"
  },
  data: () => ({
    value: {
      
    },
    pre: {
      
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      

      await this.getDetail(this.params.id).then(response => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function(url) {
      this.is_loading = true;
      axios.get(this.API_ASSET_UPLOAD_URL+url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({title: "Download Completed", message: "Download completed successfully", type: "success"});
        })
        .catch(error => {
          Notification.error({title: "Download Failed", message: "Failed to download", type: "error"});
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_pages/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {
          });
      });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
        